import { render, staticRenderFns } from "./LayoutContentRendererCustomer.vue?vue&type=template&id=241e9a5d&scoped=true&"
import script from "./LayoutContentRendererCustomer.vue?vue&type=script&lang=js&"
export * from "./LayoutContentRendererCustomer.vue?vue&type=script&lang=js&"
import style0 from "./LayoutContentRendererCustomer.vue?vue&type=style&index=0&id=241e9a5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241e9a5d",
  null
  
)

export default component.exports